import { useEffect, useState } from "react";
import { listZone } from "../lib/api";

/**
 * Hook condiviso per caricare le zone attive dal backend.
 * Restituisce { zone, loading, refresh } con `zone` array di {id, nome, colore, attiva, _nProduttori}.
 */
export function useZoneAttive() {
  const [zone, setZone] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = () => {
    setLoading(true);
    listZone(true)
      .then((d) => setZone(d || []))
      .catch(() => setZone([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => { refresh(); }, []);
  return { zone, loading, refresh };
}

export function useTutteLeZone() {
  const [zone, setZone] = useState([]);
  const [loading, setLoading] = useState(true);
  const refresh = () => {
    setLoading(true);
    listZone()
      .then((d) => setZone(d || []))
      .catch(() => setZone([]))
      .finally(() => setLoading(false));
  };
  useEffect(() => { refresh(); }, []);
  return { zone, loading, refresh };
}
